<template>
  <div>
    <div v-if="getToken">{{ this.$router.push("/balance") }}</div>
    <div v-else>
      <div class="container-center animated fadeIn">
        <div class="text-center">
          <i class="fad fa-mailbox fa-5x text-accent"></i>
          <h3>Email Verification</h3>
        </div>
        <div class="panel panel-filled">
          <div class="panel-body">
            <p>
              We've sent an email to your registered email address:
              <span class="c-white font-bold">{{ email }}</span> Follow the
              instructions in the email to get started!
            </p>
            <p class="text-accent text-center font-bold">
              Go to email and verify
            </p>
            <p>If you haven't received the email, please try the following</p>
            <ul>
              <li>Make sure the email address you provided is correct.</li>
              <li>Check your Spam or Junk mail folders.</li>
              <li>Add 365stream to your email address whitelist.</li>
              <li>Make sure your email is functioning normally.</li>
            </ul>
            <p v-if="loading" class="text-muted" disabled=" ">
              <i class="fad fa-spinner-third fa-spin m-r-xs"></i
              >{{ $t("Loading") }}
            </p>
            <p v-else class="text-accent pointer" v-on:click="resend()">
              Resend email »
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeToast from "native-toast";
import { mapGetters } from "vuex";
import auth from "@/api/auth";

export default {
  data() {
    return {
      loading: false,
      email: this.$route.params.email,
    };
  },
  computed: mapGetters(["getToken"]),
  methods: {
    async resend() {
      this.loading = true;
      await auth
        .resendemail({
          email: this.email,
        })
        .then(() => {
          this.loading = false;
          nativeToast({
            message:
              "An e-mail has been sent to " +
              this.email +
              "  with further instructions.",
            position: "top",
            timeout: 3000,
            type: "success",
          });
        })
        .catch((error) => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
  },
};
</script>
